import {environment} from '../environments/environment';
export const MapOptions = {
  license: `${environment.api.googlemapkey}`,
  map: {
    zoom : 15,
    controlSize: 24,
    typeControl: true,
    scaleControl: true,
    fullscreenControl: true,
    scrollWheel: true,
    disableDoubleClickZoom: true,
    gestureHandling: 'cooperative',
    styles: [ // align with the version of Xplorer
      {
        featureType: 'poi',
        stylers: [
          { visibility: 'off'},
          {
            featureType: 'transit',
            elementType: 'labels.icon',
            stylers: [{visibility: 'off'}]
          }]
      }
    ]
  },
  tools: {
    colors:  ['#0000ff', '#008000', '#800080', '#ff0000', '#ffff00', '#ff8c00', '#808080', '#000000',"#0000ff"],
    markerOptions: {
     // icon: 'https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png',
      draggable: true,
      //label:'123'
      //icon:'http://maps.google.com/mapfiles/ms/icons/green-dot.png'
    },
    polylineOptions: {
      //editable: true,
      draggable: true
    },
    rectangleOptions: {
      strokeWeight: 0,
      fillOpacity: 0.45,
      //editable: true,
      draggable: true
    },
    circleOptions: {
      strokeWeight: 0,
      fillOpacity: 0.45,
      //editable: true,
      draggable: true
    },
    polygonOptions: {
      strokeWeight: 0,
      fillOpacity: 0.45,
      //editable: true,
      draggable: true
    }
  },
  markerUrls:['../../assets/images/mm_20_red.png',
  '../../assets/images/mm_20_orange.png',
  '../../assets/images/mm_20_yellow.png',
  '../../assets/images/mm_20_green.png',
  '../../assets/images/mm_20_blue.png',
  '../../assets/images/mm_20_purple.png',
  '../../assets/images/mm_20_gray.png',
  '../../assets/images/mm_20_black.png',
  '../../assets/images/mm_20_white.png',
  '../../assets/images/red-stars-lv.png',
  '../../assets/images/ylw-stars-lv.png',
  '../../assets/images/grn-stars-lv.png',
  '../../assets/images/blu-stars-lv.png',
  '../../assets/images/purple-stars-lv.png',
  '../../assets/images/wht-stars-lv.png',
  '../../assets/images/red-pushpin.png',
  '../../assets/images/pink-pushpin.png',
  '../../assets/images/ylw-pushpin.png',
  '../../assets/images/grn-pushpin.png',
  '../../assets/images/ltblu-pushpin.png',
  '../../assets/images/blue-pushpin.png',
  '../../assets/images/placemark_circle.png',
  '../../assets/images/placemark_circle_highlight.png',
  '../../assets/images/placemark_square.png',
  '../../assets/images/placemark_square_highlight.png'],
  scales:['1:300000','1:150000','1:72000','1:36000','1:18000','1:9000','1:4500','1:2000','1:1000', 'scale by Aerial','scale by Topo ','scale by FIM '],
  zooms:['11','12','13','14','15','16','17','18','19', '15', '15', '17']

};
